<template>
  <div>
    <a-button @click="visibleModal = true" type="primary" icon="file-search">
    </a-button>
    <a-modal @ok="guardarCambios" width="80%" style="height: 80%" v-model="visibleModal"
             title="Lista de valores múltiple">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :actions="false"
                :parentData="params"
      >
      </g-master>
      <div v-if="rowSelected">
        <strong>Fila seleccionada:</strong> {{rowSelected}}
      </div>
    </a-modal>

  </div>
</template>

<script>
  export default {
    props: ['endpoint', 'rowKey', 'columns', 'decorator', 'saveValue', 'params'],
    data () {
      return {
        fiConfig: {
          'label-col': {span: 3},
          'wrapper-col': {span: 21},
          label: this.label,
          'has-feedback': true
        },
        visibleModal: false,
        propertySelected: '',
        valorAGuardar: '',
        data: '',
        rowSelect: [],
        master: {
          endpoint: this.endpoint,
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            actions: false,
            tableConfig: {
              rowKey: this.rowKey,
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: this.columns
          }
        }
      }
    },
    methods: {
      cancelar () {
        this.$emit('cancel')
      },
      guardarCambios () {
        this.visibleModal = false
        this.data = this.propertySelected
        this.$emit('model', this.valorAGuardar)
      }
    },
    computed: {
      rowSelected () {
        this.propertySelected = ''
        if (this.master.tableSetup.selectedRows.length > 0) {
          this.rowSelect = this.master.tableSetup.selectedRows[0]
          this.columns.map(item => {
            for (const property in this.rowSelect) {
              if (property === item.dataIndex) {
                this.propertySelected = this.propertySelected + ' ' + `${this.rowSelect[property]}`
              }
              if (property === this.saveValue) {
                this.valorAGuardar = `${this.rowSelect[property]}`
              }
            }
          })
          return this.propertySelected
        } else {
          return null
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/dropdownLarge.vue